import React,{useEffect,useRef,useState} from 'react'
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useGetAllCentersQuery, useGetAllCentersTseQuery, useGetResultMutation, useGetResultTseMutation } from '../Services/modules/result';
import Spinner from 'react-bootstrap/Spinner';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';

function PersonelResultTse() {
    const [center, setCenter] = useState('');
    const [seatNumber, setSeatNumber] = useState('');
    const [filteredData, setFilteredData] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);
  
  const[resultDisplay,setResultDisplay]=useState([])
  const[studentName,setStudentName]=useState('')
  const[studentSchool,setStudentSchool]=useState('')
  const[studentStandard,setStudentStandard]=useState('')
  const[studentSeatNumber,setStudentSeatNumber]=useState('')
  const[studentExamCenter,setStudentExamCenter]=useState('')
  const[studentExamSubject,setStudentExamSubject]=useState('')
  const[studentMarkOne,setStudentMarkOne]=useState('')
  const[studentMarkTwo,setStudentMarkTwo]=useState('')
  const[totalMarks,setTotalMarks]=useState('')

  const { 
    data: centers= [],  
    isLoading:loading=true,
    isSuccess:getCentersSuccess=false
   } = useGetAllCentersTseQuery();
   const [GetResult, 
    { data, isSuccess, isLoading, isError, error }]
     = useGetResultTseMutation();
     useEffect(() => {       
        validateForm();
      }, [center,seatNumber]);

       useEffect(() => {             
        if (getCentersSuccess) {           
           console.log("centers.data",centers)         
              setFilteredData(centers.data);            
        }
       
    }, [centers]);

    useEffect(() => {   
         
      if (isSuccess) {         
       // console.log("data",data.result[0].student_name)   
        if(data.error) 
        {
          toast.error(data.message) 
          //alert(data.result[0].student_name)
        
        }
        if(!data.error)
        {
          toast.success(data.message)  
          setStudentName(data.result[0].student_name)
          setStudentSchool(data.school_name)
          setStudentStandard(data.result[0].standard)
          setStudentSeatNumber(data.result[0].seat_number)
          setStudentSeatNumber(data.result[0].seat_number)
          setStudentMarkOne(data.result[0].mark_one)
          setStudentMarkTwo(data.result[0].mark_two)  
          setTotalMarks(data.result[0].total_marks)  
          setResultDisplay(data.result)      
        }
                  
      }
      else {
      console.log("In error")
         
      }
    }, [isLoading]);
    const validateForm = () => {
         
        
      if (center !== '' && seatNumber!=='') {
        setIsFormValid(true);
      } 
      else 
      {           
        setIsFormValid(false);
      }       
    }; 
    const handleFormSubmit = event => {
        GetResult({
          center_id:center,
          seat_number:seatNumber,
          exam_name:"tse"
        })
        };
    
  return (
    <>
     <div className='row'>
            <div className='col-md-4'>
            <div className='row' style={{marginTop:'50px'}}>
       <h4 style={{textAlign:'center'}}> वैयक्तिक निकाल खालील प्रमाणे पहा</h4>
        </div>
          
      <Form.Group controlId="exampleForm.ControlSelect1">
        <Form.Label style={{marginTop:'20px'}}>केंद्र निवडा:</Form.Label>
        <Form.Control as="select" value={center} onChange={e => setCenter(e.target.value)}>
          <option value="">Choose...</option>
          {filteredData.map(item => (
                        <option value={item.center_id}>{item.center_name}</option>
                      ))}
        </Form.Control>
         {/* <Select
    options={filteredData}
    value={filteredData.find((option) => option.value === center)}
    onChange={(selectedOption) => setCenter(selectedOption ? selectedOption.value : "")}
    placeholder="Choose..."
    isSearchable={true} // Enables search functionality
  /> */}
      </Form.Group>
      <Form.Group controlId="exampleForm.ControlInput1">
        <Form.Label style={{marginTop:'20px'}}>बैठक क्रमांक:</Form.Label>
        <Form.Control type="text" value={seatNumber} onChange={e => setSeatNumber(e.target.value)} />
      </Form.Group>
      {/* <Button 
      style={{marginTop:'20px'}} 
      variant="primary"
    //  disabled={true} 
      disabled={!isFormValid}
      type="submit">
        Submit
      </Button> */}
      <Button
  style={{ marginTop: '20px' }}
  variant="primary"
  disabled={!isFormValid || isLoading}
  type="submit"
  onClick={()=>handleFormSubmit()}
>
  {isLoading ? (
    <Spinner animation="border" role="status">
      <span className="sr-only">Loading...</span>
    </Spinner>
  ) : (
    'Submit'
  )}
</Button>
   
            </div>
            <div className='col-md-6' >
           {resultDisplay.length>0? 
           <table class="table"style={{marginTop:'40px',marginLeft:"40px"}} >
    <thead>

      <tr>
    
        <th colSpan={2} style={{textAlign:'center'}}>
          गुणवत्ता शोध परीक्षा अंतिम निकाल</th>
        
       
      </tr>
    </thead>
    <tbody>
   

      <tr>
        <td style={{textAlign:'left'}}>नाव</td>
        <td style={{textAlign:'left'}}>{studentName}</td>
       
      </tr>
      <tr>
        <td style={{textAlign:'left'}}>विद्यार्थ्याची शाळा</td>
        <td style={{textAlign:'left'}}>{studentSchool}</td>
      
      </tr>
      <tr>
        <td style={{textAlign:'left'}}>इयत्ता</td>
        <td style={{textAlign:'left'}}>{studentStandard}</td>
       
      </tr>
      <tr>
        <td style={{textAlign:'left'}}>बैठक क्रमांक</td>
        <td style={{textAlign:'left'}}>{studentSeatNumber}</td>
       
      </tr>
     
      
      {
        studentStandard==1 || studentStandard==2 ?
        <>
        <tr>
        <td style={{textAlign:'left'}}>भाषा, गणित, इंग्रजी व बुद्धिमत्ता</td>
        <td style={{textAlign:'left'}}>{studentMarkOne}</td>
       
      </tr>
         <tr>
         <td style={{textAlign:'left'}}>एकूण</td>
         <td style={{textAlign:'left'}}>{totalMarks}</td>
        
       </tr>
       </>
      :""
      }
      {
        studentStandard==3 || studentStandard==6 ?
        <>
          <tr>
        <td style={{textAlign:'left'}}>भाषा व गणित</td>
        <td style={{textAlign:'left'}}>{studentMarkOne}</td>
       
      </tr>
      <tr>
        <td style={{textAlign:'left'}}>इंग्रजी व बुद्धिमत्ता</td>
        <td style={{textAlign:'left'}}>{studentMarkTwo}</td>
       
      </tr>
      <tr>
        <td style={{textAlign:'left'}}>एकूण</td>
        <td style={{textAlign:'left'}}>{totalMarks}</td>
       
      </tr>
        </>            
      :""
      }
      
     
    </tbody>
  </table>:""}
            </div>
        </div>
    </>
  )
}

export default PersonelResultTse